// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"3f65e2b96881b5b4ebb0","551":"eeedadb5e38073822969"}[chunkId] + ".css";
};